import OrderTypeLayout from "@/pages/order-type/components/OrderTypeLayout";

export default function StopLimitOrders() {
  return <OrderTypeLayout slug="stop-limit-orders" />;
}